import { supportedDocuments } from "./supportedDocuments";

const es = {
  notFound: "Proveedor no fue encontrado",
  notFoundctx:
    "Por favor, acceda al portal con en enlace enviado via email. Si sigues viendo esta mensaje, por favor entra en contacto con nosotros via",
  supplier_portal_tag_line: `Recopile y procese sus facturas automáticamente garantizando una ejecución sin errores`,
  supplierDeleted:
    "Proveedor borrado. Compruebe tu enlace o tus autorizaciones",
  step1: "Paso 1. Selecciona",
  step1ctx: "Selecciona facturas de tus archivos.",
  step2: "Paso 2. Revisa",
  step2ctx: "Revisa si las facturas correctas fueron seleccionadas.",
  step3: "Paso 3. Carga",
  step3ctx: "Carga las facturas.",
  login: "Inicia Sesión",
  drop: "Arrastra o selecciona documentos.",
  dropctx1: "Arrastra archivos o pulsa",
  dropctx2: "explorar",
  dropctx3: "para seleccionar",
  selected: "Documentos seleccionados:",
  removeAll: "Eliminar Todo",
  upload: "Cargar documentos",
  useDedicatedLink:
    "No puedes cargar sin usar tu enlace dedicado. Por favor, utilice el enlace que le hemos enviado por correo eletronico.",
  duplicateNotAllowed: "Archivos duplicados no permitidos",
  limit: "Límite de 10 archivos.",
  successUpload: "Documento(s) cargado(s) exitosamente",
  errorUpload: "Error cargandos archivos: ",
  logout: "Cerrar sesión",
  onboardingV2: {
    step_of: "Paso {{current}} de {{total}}",
    basic_title: "Empieza por lo básico",
    basic_text:
      "Cinco pasos cortos. Puedes guardar y volver en cualquier momento.",
    bank_title: "¿Dónde debemos pagarte?",
    bank_text:
      "Los datos de pago están cifrados y solo son visibles para los aprobadores de finanzas.",
    address_title: "Tus direcciones",
    address_text: "Se usan en pedidos de compra y albaranes.",
    legal_title: "¿Quién firma por la empresa?",
    legal_text: "Firmante y documentos de identidad",
    documents_title: "Añade tus documentos",
    documents_text:
      "Los revisamos antes de poder procesar tu primera factura.",
    dni_documents: "Anverso y reverso del DNI",
    card_basic_title: "Información básica",
    card_basic_subtitle: "Proporciona tus datos esenciales",
    card_bank_title: "Información bancaria",
    card_bank_subtitle: "Dónde enviamos el pago de las facturas aprobadas.",
    card_address_title: "Información de dirección",
    card_address_subtitle:
      "Dirección registrada utilizada en pedidos de compra y facturas.",
    card_legal_title: "Representante legal",
    card_legal_subtitle:
      "La persona autorizada para firmar en nombre de la empresa.",
    card_documents_title: "Documentos",
    card_documents_subtitle:
      "Da un nombre y una fecha de caducidad a cada archivo para que podamos recordártelo antes de que venza.",
    save_later: "Guardar y continuar más tarde",
    mandatory: "Obligatorio",
    save: "Guardar",
    save_progress_title: "Guarda tu progreso",
    save_progress_text:
      "Puedes volver a iniciar sesión más tarde para terminar el resto del proceso de incorporación",
    progress_saved: "Progreso guardado",
    reset_reason: "Motivo del reinicio de la incorporación",
    mandatory_error:
      "Por favor, proporciona la información obligatoria que falta para continuar",
    profile_update_may_reset_onboarding:
      "Si actualizas alguna información aquí, tu proceso de incorporación podría reiniciarse",
    confirm_update_title: "Confirmar actualización",
  },
  email: {
    enterEmail: "Introduzca tu email para recibir un código de confirmación",
    enterEmailCtx:
      "Eso ayuda a asegurarnos de que eres tú antes de permitir cargas",
    emailAddress: "Correo electrónico",
    sendCode: "Enviar código",
    verify: "Verificar",
    checkEmail: "Introduce tu código de verificación",
    checkEmailCtx1: "Hemos enviado un código de 6 dígitos a",
    checkEmailCtx2:
      ". Por favor, introduzca el código en el hueco de abajo para verificar tu email.",
    confirm: "Confirmar",
    code: "Código",
    resend: "No has recibido?",
    resendLink: "Volver a enviar",
    codeResent: "Código fue enviado otra vez a tu email",
    wrongCode: "Código incorrecto",
  },
  loadingSupplier: "Cargando proveedor...",
  NeedReview: "Necesita revisión",
  Duplicate: "Duplicado",
  Default: "En progreso",
  Extracted: "Procesado",
  Failed: "Fallido",
  Error: "Error",
  Reviewed: "Revisado",
  "Add Document": "Añadir Documento",
  "Created on": "Creado en",
  Status: "Estado",
  Date: "Fecha",
  Message: "Mensaje",
  Close: "Cerca",

  "Document name": "Nombre del documento",
  Paid: "Pagado",
  UnPaid: "No pagado",
  Approved: "Aprobado",
  Rejected: "Rechazado",
  "Payment status": "Estado de pago",
  "ERP status": "Estado ERP",
  All: "Todos",
  Documents: "Documentos",
  documents: "Documentos",
  "Erp status": "Estado ERP",
  Actions: "Acciones",
  "Created in ERP": "Creado en ERP",
  Yes: "Si",
  No: "No",
  Pending: "Pendiente",
  "View ERP details": "Ver detalles ERP",
  "ERP Details": `Detailles ERP`,
  "View payment details": "Ver detalles de pago",
  "Payment Details": "Detalles del pago",
  "Payment Date": "Fecha de pago",
  "Transaction method": "Método de transacción",
  "Rows per page": "Filas por página",
  of: "de",
  a_maximum_of_10_files_are_allowed_in_a_single_upload: `Se permite un máximo de 10 archivos en una sola carga`,
  upload_by_device: "Subir por dispositivo",
  select_language: "Seleccionar idioma",
  no_data: `Sin Datos`,
  supplier: `Proveedor`,
  add_a_new_document: `Agregar un nuevo documento`,
  entries_per_page: `Entradas por página`,
  "Drop your files here or browse through your machine.": `Suelte sus archivos aquí o navegue por su máquina.`,
  browse: `Navegar`,
  upload_documents: `Subir Documentos`,
  upload_from_device: `Subir desde el dispositivo`,
  // Create Document
  create_document: `Crear Documento`,
  document_information: `Información del documento`,
  account_class: `Clase de cuenta`,
  account_payable: `Cuenta por pagar`,
  document_class: `Clase de documento`,
  deliveryNote: `Albarán`,
  invoice: `Factura`,
  documentNumber: `Número de documento`,
  documentDate: `Fecha del documento`,
  add_valid_date: `Agregar fecha válida`,
  documentClass_is_required: `Se requiere clase de documento`,
  documentNumber_is_required: `El número de documento es obligatorio`,
  poNumber_is_required: `Se requiere el número de orden de compra`,
  totalAmount: `Monto total`,
  taxPercentage: `Porcentaje de impuesto`,
  customer_information: `Información al cliente`,
  customerCompanyName: `Nombre de la empresa del cliente`,
  customerCompanyID: `ID de la empresa del cliente`,
  customerCompanyAddress: `Dirección de la empresa del cliente`,
  customerEmail: `Correo electrónico del cliente`,
  customerCompanyName_is_required: `El nombre de la empresa del cliente es obligatorio`,
  customerCompanyID_is_required: `Se requiere el ID de la empresa del cliente`,
  customerCompanyAddress_is_required: `Se requiere la dirección de la empresa del cliente`,
  customerEmail_is_required: `El correo electrónico del cliente es obligatorio`,
  document_is_required: `El documento es requerido`,
  account_information: `Información de la cuenta`,
  vendor_information: `Mi información`,
  items_information: `Información de los artículos`,
  taxes_information: `Información de impuestos`,
  optional: `Opcional`,
  account_receivable: `cuenta por cobrar`,
  accountClass_is_required: `Se requiere clase de cuenta`,
  back: `Atrás`,
  next: `Próximo`,
  invoiceID: `ID de factura`,
  poNumber: `Numero postal`,
  totalWithoutTax: `Total (sin impuestos)`,
  totalTax: `Total impuestos`,
  invoiceDate: `Fecha de la factura`,
  dueDate: `Fecha de vencimiento`,
  invoiceId_is_required: `Se requiere identificación de factura`,
  totalWithoutTax_is_required: `Se requiere total sin impuestos`,
  totalTax_is_required: `Se requiere el impuesto total`,
  totalAmount_is_required: `Se requiere cantidad total`,
  taxPercentage_is_required: `Se requiere porcentaje de impuesto`,
  deliveryNote_is_required: `Se requiere albarán de entrega`,
  invoiceDate_is_required: `Se requiere fecha de factura`,
  documentDate_is_required: `Se requiere fecha del documento`,
  dueDate_is_required: `Se requiere fecha de vencimiento`,
  vendorCompanyName: `Nombre de la empresa`,
  vendorCompanyID: `ID de la empresa `,
  vendorCompanyAddress: `Dirección de la empresa `,
  vendorCompanyName_is_required: `Se requiere el nombre de la empresa `,
  vendorCompanyID_is_required: `Se requiere el ID de la empresa `,
  vendorCompanyAddress_is_required: `Se requiere la dirección de la empresa`,
  referenceCode: `Código de referencia`,
  unit: `Unidad`,
  unitPrice: `Precio unitario`,
  vatPercentage: `IVA %`,
  vat: `IVA`,
  dtoPercentage: `DTO %`,
  dto: `DTO`,
  discountPercentage: `% de descuento`,
  discount: `Descuento`,
  subTotalAmount: `Monto subtotal`,
  referenceCode_is_required: `Se requiere código de referencia`,
  description_is_required: `Se requiere descripción`,
  unit_is_required: `Se requiere unidad`,
  unitPrice_is_required: `Se requiere precio unitario`,
  quantity_is_required: `Se requiere cantidad`,
  vatPercentage_is_required: `Se requiere porcentaje de IVA`,
  vat_is_required: `Se requiere IVA`,
  dtoPercentage_is_required: `Se requiere porcentaje de DTO`,
  dto_is_required: `Se requiere DTO`,
  discountPercentage_is_required: `Se requiere porcentaje de descuento`,
  discount_is_required: `Se requiere descuento`,
  subTotalAmount_is_required: `Se requiere el monto subtotal`,
  amount_is_required: `Se requiere cantidad`,
  delete_item: `Eliminar elemento`,
  update_item: `Actualizar elemento`,
  delete_items: `Eliminar objetos`,
  taxes: `Impuestos`,
  baseAmount: `Cantidad base`,
  add_tax: `Agregar impuesto`,
  submit: `Someter`,
  reset: `Reiniciar`,
  atleast_one_item_is_required: `Se requiere al menos un artículo`,
  atleast_one_tax_is_required: `Se requiere al menos un impuesto`,
  submit_and_create_new_document: `Enviar y crear un nuevo documento`,
  baseAmount_is_required: `Se requiere cantidad base`,
  vendorEmailAddress: `Dirección de correo electrónico del`,
  add_item: `Añadir artículo`,
  vendorEmail_is_required: `Se requiere la dirección de correo electrónico del`,
  email_invalid: `El correo electrónico debe ser una dirección de correo electrónico válida`,
  quantity: `Cantidad`,
  amount: `Cantidad`,
  actions: `Acciones`,
  description: `Descripción`,
  delete_approval: `Estás seguro de que quieres eliminar esto`,
  cancel_button: `Cancelar`,
  delete: `Eliminar`,
  delete_tax: `Eliminar impuesto`,
  delete_taxes: `Eliminar impuestos`,
  only_one_document_is_allowed_to_upload: `Sólo se permite cargar un documento`,
  upload_document: `Subir documento`,
  tax: `Impuesto`,
  document_created_successfully: `Documento creado exitosamente`,
  update_tax: `Actualizar impuesto`,
  my_information: `Mi informacion`,
  emailAddress: `Dirección de correo electrónico`,
  companyAddress: `Dirección de empresa`,
  companyID: `ID de empresa`,
  companyName: `El nombre de empresa`,
  companyName_is_required: `El nombre de la empresa es obligatorio`,
  companyID_is_required: `Se requiere el ID de la empresa`,
  companyAddress_is_required: `La dirección de la empresa es obligatoria`,
  email_is_required: `Se requiere dirección de correo electrónico`,
  dueDate_should_be_greater_than_documentDate: `La fecha de vencimiento debe ser mayor que la fecha del documento`,
  documentDate_should_be_less_than_dueDate: `La fecha del documento debe ser menor que la fecha de vencimiento`,
  "tax_amount_not_%": "Impuesto (monto)",
  document_details: `Detalles del documento`,
  date_details: `Detalles de la fecha`,
  logo_url: `URL del logotipo`,
  please_enter_your_information: `Por favor ingresa tu información`,
  please_enter_customer_information: `Detalles del cliente a quién se enviará este documento`,
  "Approval Process": `Proceso de aprobación`,
  tax_must_be_number: `Se requiere el impuesto y debe ser numérico`,
  discount_must_be_number: `El descuento debe ser un número`,
  unitPrice_must_be_number: `El precio unitario es obligatorio y debe ser un número`,
  quantity_must_be_number: `La cantidad es obligatoria y debe ser un número`,
  baseAmount_must_be_number: `Se requiere un monto base y debe ser un número`,
  tax_is_required: `Se requiere impuesto`,
  upload_deliveryNote: `Subir Albarán`,
  upload_invoice: `Subir Factura`,
  ustomer: `Cliente`,
  "My profile": `Mi perfil`,
  supplier_contract: `Contrato de proveedor`,
  Logout: `Cerrar sesión`,
  "Email must be a valid email address": `El correo electrónico debe ser una dirección de correo electrónico válida`,
  "Email is required": `El correo electrónico es obligatorio`,
  "Name is required": `El nombre es obligatorio`,
  registration_number_required: `Se requiere el número de registro`,
  registration_number_validation2: `El número de registro debe ser un número`,
  registration_number_validation1: `El número de registro no puede tener más de 20 caracteres`,
  iban_validation_2: `El IBAN debe ser alfanumérico`,
  iban_validation_1: `El IBAN no puede tener más de 24 caracteres`,
  "My Profile": `Mi perfil`,
  name: `Nombre`,
  Email: `Correo electrónico`,
  registration_number: `Número de registro`,
  account_holder_name: `Nombre del titular de la cuenta`,
  iban: `IBAN`,
  "Go back": `Regresar`,
  Save: `Guardar`,
  Invoice: `Factura`,
  PurchaseOrder: `Orden de compra`,
  DeliveryNote: `Albarán`,
  ERPPurchaseOrder: `Orden de compra ERP`,
  finance_screen: {
    email_text: `Tu email dedicado al envio de documentos`,
    docs_processed: `Documentos Procesados`,
    email_csv_export: `Exportar CSV en email`,
    selected_files: `Archivo(s) Seleccionados`,
    remove_all: `Eliminar todo`,
    upload_files: `Cargar Archivos`,
    duplicate_files_are_not_allowed: `No se permiten archivos duplicados`,
    files_cannot_be_more_than_10: `Los archivos no pueden ser más de 10`,
    document_uploaded_successfully: `Documento subido correctamente`,
    extract_now: `Extraer ahora`,
    all: `Todo`,
    Invoice: `Facturas`,
    PurchaseOrder: `Ordenes de compra`,
    credit_memo: `Abono`,
    DeliveryNote: `Albaranes`,
    Reciepts: `Recibos`,
    filename: `Nombre del archivo`,
    processed_at: `Procesado el`,
    output: `Salida`,
    status: `Estado`,
    creeated_in_erp: `Creado en el ERP`,
    no_data: `Sin Datos`,
    dense: `Justificado`,
    rows_per_page: `Líneas por página:`,
    retry_button: `Reintentar`,
    yes_button: `Sí`,
    no_button: `No`,
    start_date: `Fecha de inicio`,
    end_date: `Fecha final`,
    search: `Buscar`,
    document_upload_unsuccessful: `Error al cargar el documento`,
    "Document not supported": `Documento no compatible`,
    "Number of pages exceed": `Número de páginas excedido`,
    "Limit Exceed": `Límite de documentos excedido`,
    document_name: `Nombre del documento`,
    SimpleNote: `Nota Simple`,
    WorkContract: `Contrato de trabajo`,
    Payroll: `Nómina`,
    DNI: `DNI`,
    Passport: `Pasaporte`,
    NIE: `NIE`,
    SimulatedInvoice: `Factura Simulada`,
    output_data: `Datos de salida`,
    CreditNote: `Abono`,
    failed_to_fetch_document_version_id: `No se pudo obtener el ID de la versión del documento`,
  },
  status: {
    in_process: `En proceso`,
    processed: `Procesado`,
    failed: `Error`,
    error: `Error`,
    need_review: `Revisar`,
    reviewed: `Revisado`,
    duplicate: `Duplicado`,
    connected: `Conectado`,
    not_connected: `No Conectado`,
    success: `Éxito`,
    plan: `libre`,
  },
  Filters: `Filtros`,
  "Document status": `Estado del documento`,
  "Approval status": `Estado de aprobación`,
  "ERP integrated": `ERP integrado`,
  "Include deleted documents": `Incluir documentos eliminados`,
  "Clear all": `Limpiar todo`,
  "Search ...": `Buscar ...`,
  "Create Purchase order": `Crear orden de compra`,
  "Upload Purchase Order": `Cargar orden de compra`,
  "Upload purchase order": `Cargar orden de compra`,
  "Delete document": `Eliminar documento`,
  "Are you sure you want to delete this document?": `¿Estás seguro de que quieres eliminar este documento?`,
  "Are you sure you want to delete all documents?": `¿Estás seguro de que quieres eliminar todos los documentos?`,
  "Are you sure you want to delete these documents?": `¿Estás seguro de que quieres eliminar estos documentos?`,
  "IBAN cannot be more than 24 characters": `El IBAN no puede tener más de 24 caracteres`,
  "IBAN is required": `El IBAN es obligatorio`,
  "IBAN is not valid": `El IBAN no es válido`,
  CreditNote: `Abono`,
  DebitNote: `Nota de débito`,
  account_holder_name_required: `Se requiere el nombre del titular de la cuenta`,
  NeedApproval: `Necesita aprobación`,
  Onboarding: `En proceso`,
  "Complete Your Profile": `Completa tu perfil`,
  "You're almost done! Complete any missing information to finish your setup.": `¡Casi terminas! Completa cualquier información faltante para finalizar tu configuración.`,
  "Bank Details": `Detalles bancarios`,
  "Verify Your Bank Details": `Verifica tus detalles bancarios`,
  "Review your bank information and fill in any gaps for smooth transactions.": `Revise su información bancaria y complete cualquier vacío para transacciones sin problemas.`,
  Profile: `Perfil`,
  "Supplier Updated": `Proveedor actualizado`,
  deleted_documents: `Documentos eliminados`,
  deleted_document: `Documento eliminados`,
  something_went_wrong: `Algo salió mal`,
  unauthorized: `No autorizado`,
  supplier_has_pending_workflow: `Este proveedor tiene un flujo de trabajo pendiente. Por favor, espera a que se complete antes de subir documentos.`,
  supplier_suspended: `Este proveedor está suspendido. No se permite la subida de documentos.`,
  "Company ID": `ID de la empresa`,
  "Onboarding completed": `Registro completado`,
  supplier_profile_under_review_with_reason: `Su perfil de proveedor ha sido enviado y actualmente está en revisión debido a {{reason}}. Le notificaremos una vez que sea aprobado.`,
  supplier_profile_under_review: `Su perfil de proveedor ha sido enviado y actualmente está en revisión. Le notificaremos una vez que sea aprobado.`,
  Finish: `Terminar`,
  Continue: `Continuar`,
  Back: `Atrás`,
  "Nationality is required": "Se requiere la nacionalidad",
  "Tax Identification Number is required":
    "Se requiere el Número de Identificación Fiscal",
  "Registered address is required": "Se requiere la dirección registrada",
  "Company Description is required":
    "Se requiere la Descripción de la Compañía",
  "Power Attorney is required": "Se requiere el Poder Notarial",
  "Full Name is required": "Se requiere el Nombre Completo",
  "Document is required": "Se requiere el Documento",
  "Address is required": "Se requiere la dirección",
  "Bank Account Ownership is required":
    "Se requiere la Propiedad de la Cuenta Bancaria",
  "Compliance With Social Security is required":
    "Se requiere Cumplimiento con la Seguridad Social",
  "Compliance With Tax Administration is required":
    "Se requiere Cumplimiento con la Administración Tributaria",
  "Last Month Payment Intallment Of Civil Liability Insurance Policy is required":
    "Se requiere la última cuota del mes de la Póliza de Seguro de Responsabilidad Civil",
  "Goods and Services is required": "Se requieren Bienes y Servicios",
  "Acceptance of Terms and Conditions is required":
    "Se requiere la Aceptación de Términos y Condiciones",
  "Supported Documents": "Documentos Soportados",
  "Terms & Conditions": "Términos y Condiciones",
  "Legal Entity": "Entidad Legal",
  "Company name": "Nombre de la empresa",
  Nationality: "Nacionalidad",
  "Tax Identification Number (NIF)": "Número de Identificación Fiscal (NIF)",
  "Email address": "Dirección de correo electrónico",
  "Registered address": "Dirección registrada",
  "Description of the Company’s Activity (corporate purpose)":
    "Descripción de la Actividad de la Empresa (propósito corporativo)",
  "Legal Representative": "Representante Legal",
  "Power of Attorney": "Poder Notarial",
  "ID/NIE/Passport/equivalent document":
    "ID/NIE/Pasaporte/documento equivalente",
  Individual: "Individual",
  "Full Name": "Nombre completo",
  Address: "Dirección",
  "Certificate of Bank Account Ownership.":
    "Certificado de Propiedad de Cuenta Bancaria.",
  "Certificate of Compliance with Social Security":
    "Certificado de Cumplimiento con la Seguridad Social",
  "Certificate of Compliance with the Tax Administration.":
    "Certificado de Cumplimiento con la Administración Tributaria.",
  "Certificate of Payment for the Last Monthly Installment of the Civil Liability Insurance Policy":
    "Certificado de Pago de la Última Cuota Mensual de la Póliza de Seguro de Responsabilidad Civil",
  "Goods / Services": "Bienes / Servicios",
  "By checking this box, I confirm that I have read, understood, and agree to the":
    "Al marcar esta casilla, confirmo que he leído, entendido y acepto los",
  "Terms and Conditions": "Términos y Condiciones",
  ", including compliance with all applicable regulations and guidelines.":
    ", incluyendo el cumplimiento de todas las regulaciones y directrices aplicables.",
  "Other conditions": "Otras condiciones",
  View: "Ver",
  "An unexpected error has occured": "Ha ocurrido un error inesperado",
  "Profile updated": "Perfil actualizado",
  "An error has occured": "Ha ocurrido un error",
  "View document": `Ver documento`,
  "Impersonate Supplier Sign In": "Suplantar el inicio de sesión del proveedor",
  impersonate_token_invalid:
    "Este enlace de suplantación ha caducado o ya ha sido utilizado",
  // Onboarding
  currency: `Moneda`,
  address: `Dirección`,
  currency_is_required: `La moneda es obligatoria`,
  address_is_required: `La dirección es obligatoria`,

  // Lista de estados del documento en Cardonar
  POSTED: "contabilizada",
  PENDING_POSTING: "pendiente de contabilizar",
  APPROVED: "Aprobado",
  REJECTED: "Rechazado",
  NOT_EXIST: "No existe",
  PENDING: "Pendiente",
  PAID: "Pagado",
  UNPAID: "No pagado",
  PENDING_PAYMENT: "Pendiente de pago",
  Code: "Código",
  "Expected Payment Date": "Fecha de pago esperada",
  "Payment Info": "Información de pago",
  // Transactions
  queries: `Consultas`,
  answer_query: `Responder consulta`,
  send_answer: `Enviar respuesta`,
  answer: `Respuesta`,
  question: `Pregunta`,
  raised_by: `Planteada por`,
  raised_on: `Fecha`,
  entity_type: `Tipo de entidad`,
  query_status_pending: `Pendiente`,
  query_status_answered: `Respondida`,
  query_status_closed: `Cerrada`,
  query_answered_successfully: `Consulta respondida correctamente`,
  transactions: `Transacciones`,
  transaction_date: `Fecha de la transacción`,
  customer_name: `Nombre del cliente`,
  view_invoices: `Ver facturas`,
  transaction_details: "Detalles de la transacción",
  invoices: `Facturas`,
  total_amount: "Monto total",
  paid_amount: "Monto pagado",
  payment_details: `Detalles de pago`,
  created_on: `Creado el`,
  vendor_name: `Nombre del vendedor`,
  transacted_on: `Transacción realizada el`,
  invoice_payments: `Pagos de Facturas`,
  Due: `Vencido`,
  Process: `Proceso`,
  PartialPaid: `Pago Parcial`,
  transaction_id: `ID de Transacción`,
  created_by: `Creado por`,
  // Permissions
  access_forbidden: `Acceso prohibido`,
  you_dont_have_permission_to_access_this_page: `No tienes permiso para acceder a esta página`,
  go_to_homepage: `Ir a la página de inicio`,
  page_not_found: `Página no encontrada`,
  "The page you are looking for might have been removed or its name changed or is temporarily unavailable.":
    "Es posible que la página que estás buscando haya sido eliminada o que su nombre haya cambiado o que no esté disponible temporalmente.",
  view_contract: `Ver contrato`,
  file_size_exceeds_the_limit: `El tamaño del archivo excede el límite`,
  failed_to_fetch_supplier_profile:
    "No se pudo obtener el perfil del proveedor",
  not_document_owner: `Acción denegada: no eres el propietario de este documento.`,
  contract_details: "Detalles del contrato",
  verify_your_contract_details: "Verifica los detalles de tu contrato",
  "Invalid file type. Only PDF, DOCX, JPG, and PNG are allowed.":
    "Tipo de archivo no válido. Solo se permiten PDF, DOCX, JPG y PNG.",
  supplier_contract_cannot_uploaded:
    "No se puede subir el contrato del proveedor",
  contract_removed_successfully: "Contrato eliminado con éxito",
  remove: "Eliminar",
  delete_contract: `Eliminar contrato`,
  delete_contract_warning: `El contrato eliminado no se puede recuperar`,
  tax_type: `Tipo de impuesto`,
  tax_type_is_required: `Se requiere el tipo de impuesto`,
  recurring_invoice: `Factura recurrente`,
  "Something went wrong": `Algo salió mal`,
  recurring_invoice_information: `Información de la factura recurrente`,
  IsRecurringGeneratedDocument: `¿Es un documento generado recurrente?`,
  invoiceDueInDays: `Factura vencida en días`,
  recurringFrequencyType: `Tipo de frecuencia recurrente`,
  startDate_is_required: `Se requiere la fecha de inicio`,
  endDate_is_required: `Se requiere la fecha de finalización`,
  invoiceDueInDays_is_number: `La factura vencida en días debe ser un número`,

  invoiceDueInDays_is_required: `La factura vencida en días es obligatoria`,
  recurringFrequencyType_is_required: `El tipo de frecuencia recurrente es obligatorio`,
  recurring_source: `Fuente recurrente`,
  recurring_generated: `Generado recurrente`,
  delete_and_create_new: `Eliminar y crear nuevo`,
  delete_recurring_document_approval: `¿Está seguro de que desea eliminar este documento y crear uno nuevo?`,
  source_document: `Documento fuente`,
  source_document_id: `ID del documento fuente`,
  "Original document": `Documento original`,
  RecurringByMinutes: `Cada X minutos`,
  Yearly: `Anualmente`,
  Monthly: `Mensualmente`,
  Weekly: `Semanalmente`,
  Daily: `Diariamente`,
  ExpenseCategory: `Categoría de gastos`,
  TaxType: `Tipo de impuesto`,
  taxType: `Tipo de impuesto`,
  taxType_is_required: `El tipo de impuesto es obligatorio`,
  companyID_cannot_contain_comma: `El ID de la empresa no puede contener comas`,
  "See more": `Ver más`,
  Messages: `Mensajes`,
  "Output data": `Datos de salida`,
  "Document Messages": `Mensajes del documento`,
  no_: "No.",
  document_date: "Fecha del documento",
  vendor_address: "Dirección del proveedor",
  vendor_id: "ID del proveedor:",
  code: "Código",
  purchase_order: "Orden de compra",
  delivery_note: "Albarán/proforma",
  unit_price: "Precio unitario",
  subtotal: "Subtotal",
  total_without_tax: "Total (sin impuestos)",
  total_tax: "Total de impuestos",
  total: "Total",
  of_: "de",
  "Create Delivery Note": "Crear albarán",
  "Create Invoice": "Crear factura",
  "Catalog item": "Artículo del catálogo",
  WHT: "Retención de impuestos",
  VAT: "IVA",
  startDate: "Fecha de inicio",
  endDate: "Fecha de finalización",
  tax_info_not_required: `La información fiscal no es necesaria ya que está incluida en la información de los artículos. Sin embargo, puede especificar la retención en la fuente (WHT) si corresponde.`,
  daily: `Diario`,
  weekly: `Semanal`,
  monthly: `Mensual`,
  yearly: `Anual`,
  // Notes
  notes: `Notas`,
  note: `Nota`,
  view_notes: `Ver notas`,
  add: `Agregar`,
  close: `Cerrar`,
  no_data_found: `No se encontraron datos`,
  resource_not_found: `Recurso no encontrado`,
  add_filter: `Agregar filtro`,
  document_filters: `Filtros de documento`,
  field_name: `Nombre del campo`,
  field_value: `Valor del campo`,
  field_value_is_required: `El valor del campo es obligatorio`,
  field_name_is_required: `El nombre del campo es obligatorio`,
  view_details: `Ver detalles`,
  delete_note_title: `Eliminar nota`,
  add_a_note: `Agregar una nota`,
  no_notes_found: `No se encontraron notas`,
  note_is_required: `La nota es obligatoria`,
  note_validation_max_length: `La nota no puede tener más de 1000 caracteres`,
  notes_length_exceed: `Se ha excedido la longitud de las notas`,
  note_deletedBy_deletedOn: `Eliminado por {{deletedBy}} el {{deletedOn}}`,
  document_note_not_owner: `No eres el propietario de esta nota y no puedes realizar esta acción.`,
  error_parsing_supplier_info: `Error al analizar la información del proveedor`,
  document_not_exist: `El documento no existe`,
  general_information: `Información general`,
  legal_information: `Información legal`,
  street: "Calle",
  city: "Ciudad",
  county: "Provincia",
  municipality: "Municipio",
  postcode: "Código postal",
  province: "Provincia",
  street_number: "Número de calle",
  zipCode: "Código postal",
  id_card_front_document: "DNI (Anverso)",
  id_card_back_document: "DNI (Reverso)",
  upload_front_id_card: "Subir anverso del DNI",
  upload_back_id_card: "Subir reverso del DNI",
  document_code: "Código del documento",
  first_name: `Nombre de pila`,
  last_name: `Apellido`,
  basic_info: `Información básica`,
  companies: `Empresas de clientes`,
  address_info: `Información de la dirección`,
  additional_documents: `Documentos adicionales`,
  zip_code: `Código postal`,
  fax_number: `NÃºmero de fax`,
  contact_number: `NÃºmero de contacto`,
  "Complete your address and contact details.": `Completa tus datos de dirección y contacto.`,
  document_type: `Tipo de documento`,
  number: `Número`,
  country: `País`,
  legal_representative_details: ` Detalles del representante legal`,
  verify_your_legal_representative_details: `Verifica los detalles de tu representante legal`,
  legal_representative_information: `Información del representante legal`,
  total_discount: `Descuento total`,
  dni_number: `DNI number`,
  other_details: `Otros detalles`,
  transaction_detail: `Detalle de la transacción`,
  consenturl: "URL de consentimiento",
  transactionStatus: `Estado`,
  legal_documents: `Documentos legales`,
  project_number: `Número de proyecto`,
  document: `Documento`,
  signed_contract: `Contrato firmado`,
  add_document: `Añadir documento`,
  current_payment: `Doc Corriente Pago`,
  no_documents_found: `No se encontraron documentos`,
  project_number_is_required: `Se requiere el número de proyecto`,
  document_type_is_required: `Se requiere el tipo de documento`,
  "Review Your legal documents": `Revise sus documentos legales`,
  "Check the details of your uploaded documents.": `Verifique los detalles de sus documentos subidos`,
  email_address: `Dirección de correo electrónico`,
  preview_file: `Archivo de vista previa`,
  only_one_file_is_allowed_to_upload: `Sólo se permite cargar un archivo`,
  discounts_information: `Información de descuentos`,
  total_after_discount: `Total después del descuento`,
  total_before_discount: `Total antes del descuento`,
  "attach_support_document_(optional)": `Adjuntar documento de soporte (opcional)`,
  companyid_must_be_unique: `El ID de la empresa debe ser único`,
  signature: `Firma`,
  comments: `Comentarios`,
  field_name_cannot_exceed_characters: `{{fieldName}} no puede exceder los {{number}} caracteres.`,
  approval_pending: `Aprobación pendiente`,
  approval_accepted: `Aprobación aceptada`,
  approval_rejected: `Aprobación rechazada`,
  approval_rejected_reason: `Rechazada razón`,
  reason: `Razón`,
  obResetReason: `Motivo de Reinicio de Incorporación`,
  ob_rejection_text: `Su solicitud en el portal del proveedor ha sido rechazada. Por favor, contacte al cliente para más detalles.`,
  view_more: `Ver más`,
  onboarding: `En proceso`,
  supplierpayment: {
    supplier_Onboarding_incomplete:
      "La incorporación del proveedor está incompleta",
  },

  //Volotea
  // Volotea Profile & Onboarding
  volotea_profile: "Perfil de Volotea",
  Volotea_Onboarding: "Incorporación de Volotea",

  // Header Info
  triggered_by: "Iniciado por",
  // email_address: "Correo electrónico",
  // registration_number: "Número de registro",
  vendor_company_name: "Nombre de la empresa proveedora",

  customer_company: "Empresa cliente",
  payment_terms: "Condiciones de pago",

  buyer_name: "Nombre del comprador",
  buyer_manager: "Gerente de compras",

  service_country: "País del servicio",
  vendor_type: "Tipo de proveedor",
  vendor_company_address: "Dirección de la empresa proveedora",

  amos_code: "Código AMOS",
  service_description: "Descripción del servicio",
  official_document_uploaded: "Documento oficial",

  // Entity Details
  entity_details: "Detalles de la entidad",
  company_type: "Tipo de empresa",
  // tax_type: "Tipo de impuesto",

  // Address section
  addresst: "Dirección fiscal",
  // country: "País",

  // Contact Info
  supplier_type: "Tipo de proveedor",
  contact_name: "Nombre del contacto de contabilidad",
  contact_email: "Correo electrónico de contabilidad",
  contact_phone: "Teléfono de contabilidad",

  // Status
  validation_status: "Estado de verificación",
  document_validation_status: "Estado de validez del documento",

  // Banking Info
  banking_information: "Información bancaria",
  bank_name: "Nombre del banco",
  // iban: "IBAN",
  swift_code: "Código SWIFT/BIC",
  // currencyb: "Moneda de la cuenta bancaria",

  // Documents
  documents_certificates: "Documentos y certificados",
  additional_certificate: "Certificados adicionales",
  bank_certificate: "Certificado bancario",
  tax_residence_certificate: "Residencia fiscal",

  // optional: "Opcional",

  //  Dropdown Values
  "Type A": `Persona Física`,
  "Type B": `Persona Jurídica`,
  Goods: `Bienes`,
  Services: `Servicios`,
  Both: `Ambos`,
  // Pending: "Pendiente",
  favorable: "Favorable",
  unfavorable: "Desfavorable",
  current: "Vigente",

  IndividualP: "Persona Física",
  Legal_Entity: "Persona Jurídica",

  //trigger by
  buyer: "Buyer",
  // supplier: "Supplier",

  // Vendor Type
  AyudNav: `AyudNav`,
  Call_center: `Centro de atención`,
  Commercial: `Comercial`,
  Consulting: `Consultoría`,
  Distribution_cost: `Costes de distribución`,
  Employee: `Empleado`,
  Fuel: `Combustible`,
  Handling: `Asistencia en tierra (Handling)`,
  HR: `RRHH (Recursos Humanos)`,
  Incidents: `Incidencias`,
  Insurance: `Seguros`,
  Leasing: `Arrendamiento (Leasing)`,
  Legal: `Legal`,
  Maintenance: `Mantenimiento`,
  Marketing: `Marketing`,
  Navitaire: `Navitaire`,
  Ops: `Operaciones`,
  Other: `Otro`,
  System: `Sistemas`,
  Tax: `Impuestos`,
  Training: `Formación`,
  Travel: `Viajes`,

  // Service Countries
  Spain: `España`,
  France: `Francia`,
  Italy: `Italia`,
  Greece: `Grecia`,
  "More than one": `Más de uno`,
  "None of the above": `Ninguno de los anteriores`,

  // Bill To
  "Volotea, S.L.": `Volotea, S.L.`,
  "Volotea Flight Academy, S.L.U.": `Volotea Flight Academy, S.L.U.`,

  // Payment Terms
  "0D - Due date invoice date": `0D - Fecha de factura`,
  "30D - Due date 30 days": `30D - Vencimiento a 30 días`,
  "45D - Due date 45 days": `45D - Vencimiento a 45 días`,
  "60D - Due date 60 days": `60D - Vencimiento a 60 días`,

  //validations
  Company_Type_is_required: `El tipo de empresa es obligatorio`,
  Tax_Type_is_required: `El tipo de impuesto es obligatorio`,
  Name_is_required: `El nombre es obligatorio`,
  Email_must_be_a_valid_email_address: `Debe ser un correo electrónico válido`,
  Company_ID_is_required: `El número de registro es obligatorio`,
  Address_is_required: `La dirección es obligatoria`,
  Country_is_required: `El país es obligatorio`,
  Supplier_Type_is_required: `El tipo de suministro es obligatorio`,
  Contact_Name_is_required: `El nombre de contacto es obligatorio`,
  Invalid_email: `Correo inválido`,
  Contact_Email_is_required: `El email de contacto es obligatorio`,
  Contact_Phone_is_required: `El teléfono de contacto es obligatorio`,
  Bank_Name_is_required: `El nombre del banco es obligatorio`,
  IBAN_is_required: `El IBAN es obligatorio`,
  IBAN_must_contain_only_numbers: `El IBAN debe contener solo números`,
  Currency_is_required: `La moneda es obligatoria`,
  Additional_Certificate_is_required: `El certificado adicional es obligatorio`,
  Bank_Certificate_is_required: `El certificado bancario es obligatorio`,
  //Verifactu
  regular_invoice: `Factura regular`,
  verifactu_document: `Documento verifactu`,
  companyEmail: `Correo electrónico de la empresa`,
  tax_percentage: `Porcentaje de impuesto`,
  verifactu_regular_invoice: `Factura regular`,
  verifactu_create_document: `Crear documento VeriFactu`,
  comments_max_length: "Los comentarios no pueden exceder los 500 caracteres",
  simplified_invoice: `Factura simplificada`,
  RegularInvoice: `Factura regular`,
  SimplifiedInvoice: `Factura simplificada`,
  ComplianceDetails: "Detalles de Cumplimiento",
  URL: "URL",
  CompliantBy: "Cumplido por",
  UpdatedOn: "Actualizado en",

  verifactu_corrective_invoice: `Factura rectificativa`,
  CorrectiveInvoice: `Factura rectificativa`,
  create_verifactu_document: `Crear documento Verifactu`,
  correctiveInvoice_by_substitution: `Factura rectificativa por sustitución`,
  correctiveInvoice_by_differences_tooltip: `Ajustar sólo líneas o cantidades específicas`,
  correctiveInvoice_by_substitution_tooltip: `Reemplazar la factura completa`,
  rectificationReason_is_required: `Se requiere el motivo de la rectificación`,
  rectificationReason: `Motivo de la rectificación`,
  correctiveInvoice_quantityCorrection: `Corrección de cantidad`,
  correctiveInvoice_priceAdjustment: `Ajuste de precio`,
  correctiveInvoice_discountApplied: `Descuento aplicado`,
  correctiveInvoice_partialCancellation: `Cancelación parcial`,
  correctiveInvoice_fullCancellation: `Cancelación total`,
  upload_creditNote: `Subir Abono`,
  alternate_bank_details: "Datos bancarios alternativos",
  vendor_company_id: "Número de identificación fiscal",
  person: `Persona`,
  company: `Empresa`,

  failed_to_fetch_notifications: "No se pudieron obtener las notificaciones",
  new_app_verion_available:
    "Por favor, actualiza la página para obtener la última versión de Dost.",
  update_available: "Nosotras hemos hecho algunas mejoras",
  refresh: "refrescar",
  preview_and_print: "Vista previa e impresión",
  preview_document: "Vista previa del documento",
  powered_sage: "Powered by CONTROL AI SOLUTIONS",
  view_predfined_values: "Ver valores predefinidos",
  field_title: "Valores de {{field}}",
  label: "Etiqueta",
  tax_fields_are_required: `Los campos de impuestos son obligatorios`,
  item_fields_are_required: `Los campos de artículos son obligatorios`,
  upload_signature: `Subir firma`,
  erp_purchase_order_table: {
    DocumentNo: "Número de documento",
    AllocationDate: "Fecha de asignación",
    No: "No",
  },
  "Verify Your Address Details": "Verifique sus datos de dirección",
  address_details_subtext:
    "Por favor, verifique sus datos de dirección y complete cualquier información faltante.",
  ob_finalize_text:
    "GRACIAS. SE LE NOTIFICARÁ UNA VEZ QUE LA OB ESTÉ FINALIZADA",
  onboarding_complete: "Registro Submitido",
  supplier_not_found: `Proveedor no encontrado`,
  drag_and_drop_your_files_here: `Arrastra y suelta tus archivos aquí`,
  files_accepted_only: `Solo se aceptan {{acceptedFiles}} archivos`,
  browse_files: `Explorar archivos`,
  document_name_is_required: `Se requiere el nombre del documento.`,
  cancel: `Cancelar`,
  upload_your_document: `Sube tu documento`,
  // Supported Documents

  ...supportedDocuments,

  // duplicate-document-number dialog (existing)
  document_number_already_exists: `El número de documento ya existe`,
  document_number_exists_message: `Ya se ha asignado este número de documento: {{documentNumber}}`,
  would_you_like_to_generate_new_document_number: `¿Le gustaría generar un nuevo número de documento?`,
  regenerate_document_number: `Regenerar número de documento`,
  document_number_regenerated_successfully: `Número de documento regenerado correctamente`,

  // section headings
  verifactu_simplified_invoice: `Factura simplificada de Verifactu`,
  sii_simplified_invoice: `Factura simplificada SII`,
  sii_regular_invoice: `Factura regular SII`,
  verifactu_debit_note: `Nota de débito Verifactu`,
  sii_credit_note: `Nota de crédito SII`,
  verifactu_credit_note: `Nota de crédito Verifactu`,
  sii_corrective_invoice: `Factura rectificativa SII`,
  sdi_regular_invoice: `Factura regular SDI`,
  sdi_credit_note: `Nota de crédito SDI`,

  // document info fields
  SpainCorrectionCode: `Código de rectificación`,

  // company / contact
  Currency: `Divisa`,

  // customer address breakdown
  CustomerCompanyStreet: `Calle de la empresa cliente`,
  CustomerCompanyStreetNumber: `Número de calle de la empresa cliente`,
  CustomerCompanyLocality: `Localidad de la empresa cliente`,
  CustomerCompanyRegion: `Región de la empresa cliente`,
  CustomerCompanyZipCode: `Código postal de la empresa cliente`,
  CustomerCountry: `País del cliente`,
  customerCompanyStreet_is_missing: `Falta la calle de la empresa cliente`,
  customerCompanyStreetNumber_is_missing: `Falta el número de calle de la empresa cliente`,
  customerCompanyLocality_is_missing: `Falta la localidad de la empresa cliente`,
  customerCompanyRegion_is_missing: `Falta la región de la empresa cliente`,
  customerCompanyZipCode_is_missing: `Falta el código postal de la empresa cliente`,
  your_information: `Tu información`,

  // vendor address breakdown
  VendorCompanyStreet: `Calle de la empresa`,
  VendorCompanyStreetNumber: `Número de calle de la empresa vendedora`,
  VendorCompanyLocality: `Localidad de la empresa vendedora`,
  VendorCompanyRegion: `Región de la empresa vendedora`,
  VendorCompanyZipCode: `Código postal de la empresa vendedora`,
  VendorCountry: `País del vendedor`,

  // buttons / status
  configuration: `Configuración`,

  // stacked layout (new UI)
  create_compliance_standard_document: `Crear {{complianceStandard}} {{documentType}}`,
  customize_invoice_sequencing: `Personalizar la secuencia de facturas`,
  configure_document_series: `Configurar serie de documentos`,
  verifactu: `Verifactu`,
  sdi: `SDI`,
  sii: `SII`,
  logo_url_missing: `Falta la URL del logotipo`,
  edit_my_information: `Editar información`,
  fill_my_details: `Complete los detalles para agregarlos a su lista`,
  add_logo_url: `Agregar URL del logotipo`,
  vendor_email_address: `Correo electrónico`,
  company_street: `Calle de la empresa`,
  company_street_number: `Número de calle`,
  company_locality: `Localidad`,
  company_zip_code: `Código postal`,
  company_region: `Región`,
  add_po_number: `Agregar número de OC`,
  po_number: `Número de OC`,
  add_delivery_note: `Agregar nota de entrega`,
  add_pec_code: `Agregar código PEC`,
  pec_code: `Código PEC`,
  pec_code_is_missing: `Falta el código PEC`,
  add_destination_code: `Agregar código de destino`,
  destination_code: `Código de destino`,
  destination_code_is_missing: `Falta el código de destino`,
  invoice_information: `Información de la factura`,
  purchase_order_information: `Información de la orden de compra`,
  delivery_note_information: `Información de la nota de entrega`,
  connected_documents: `Documentos conectados`,
  search_or_add_a_new_customer: `Buscar o agregar un nuevo cliente`,
  "no_items_added-click_on_add__line_item_to_add_items": `No se han agregado artículos — haga clic en "Agregar artículo" para agregarlos`,
  line_items: `Artículos`,
  add_line_item: `Agregar artículo`,
  search_by_reference_code_or_description_or_add_new_item: `Buscar por código de referencia o descripción, o agregar nuevo artículo`,
  search_by_reference_code_description_keywords: `Buscar por código, descripción, palabras clave`,
  add_discount: `Agregar descuento`,
  also_add_this_item_to_catalog: `Agregar también este artículo al catálogo`,
  total_breakdown: `Desglose total`,
  wht_tax: `Retención`,
  additional_options: `Opciones adicionales`,
  additional_tax: `Impuesto adicional`,
  support_documents: `Documentos de soporte`,
  supporting_documents: `Documentos de respaldo`,
  discount_type: `Tipo de descuento`,
  percentage: `Porcentaje`,
  base_amount: `Importe base`,
  make_recurring_invoice: `Hacer factura recurrente`,
  preview_pdf: `Vista previa PDF`,
  taxes_permission_required: `Se requiere permiso de impuestos`,
  add_new_tax: `Agregar nuevo impuesto`,
  edit_tax: `Editar impuesto`,
  rate: `Tasa`,
  is_withholding_tax: `Es impuesto de retención`,
  VAT_label: `VAT - Impuesto sobre el Valor Añadido`,
  IGIC_label: `IGIC - Impuesto General Indirecto Canario`,
  IRPF_label: `IRPF - Impuesto sobre la Renta de las Personas Físicas`,
  WHT_label: `WHT - Impuesto de retención`,
  tax_type_required: `El tipo de impuesto es obligatorio`,
  rate_required: `La tasa es obligatoria`,
  rate_min: `La tasa debe ser mayor o igual a 0`,
  tax_created_success: `Impuesto creado exitosamente`,
  tax_updated_success: `Impuesto actualizado exitosamente`,
  error_fetching_tax_data: `Error al obtener los datos del impuesto`,
  update: `Actualizar`,

  // modal de edición de cliente
  edit_customer_information: `Editar información del cliente`,
  fill_customer_details: `Complete los datos del cliente para agregarlo a su lista`,
  customer_address: `Dirección del cliente`,
  customer_company_name: `Nombre del cliente`,
  customer_company_ID: `ID del cliente`,
  customer_email_address: `Correo electrónico del cliente`,
  customerCurrency_is_required: `La moneda del cliente es obligatoria`,
  delete_customer_title: `¿Está seguro de que desea eliminar al cliente?`,
  delete_customer_warning: `Eliminar al cliente no lo borrará, pero sí lo eliminará de su factura`,
  delete_vendor_title: `¿Está seguro de que desea eliminar al proveedor?`,
  delete_vendor_warning: `Eliminar al proveedor no lo borrará, pero sí lo eliminará de su factura`,
  item_delete_title: `¿Está seguro de que desea eliminar este artículo(s)?`,
  item_delete_warning: `Eliminar el artículo lo eliminará de su factura`,
  // opciones adicionales
  item_level_discount_already_added: `Ya hay un descuento aplicado a nivel de artículo. Deshabilítelo antes de agregar un descuento a nivel de documento.`,

  // modal de serie de documentos (nuevo UI)
  customize_invoice_sequencing_number: `Personalizar el número de secuencia de facturas`,
  sequence_number_sub_text: `Cree una nueva regla de numeración, o vea las reglas existentes y anteriores`,
  add_new_sequencing_rule: `Agregar nueva regla de numeración`,
  add_new_sequence_rule_description: `Agregar una nueva regla reemplaza la regla activa actual`,
  add_new_rule: `Agregar nueva regla`,
  starting_number: `Número inicial`,
  delete_series: `¿Eliminar serie?`,
  delete_series_warning: `Eliminar esta serie la eliminará de su documento.`,
  deactive_series: `Serie desactivada`,
  deactivate: `Desactivar`,
  deactivate_sequence_title: `¿Desactivar esta secuencia?`,
  deactivate_sequence_note: `Nota: Necesitará una secuencia activa para crear nuevas facturas.`,
  add_new: `Agregar nuevo`,
  add_series_warning: `Al añadir esta serie se reemplazará la activa. ¿Continuar?`,
  select_or_type_vendor_company_id: `Seleccionar ID de empresa proveedora`,
  invoicecompliance_module_not_enabled: `El módulo de cumplimiento de facturas no está habilitado.`,
  please_enter_company_name: "Por favor, ingrese un nombre de empresa",
  please_select_company_id: "Por favor, seleccione un ID de empresa",
  please_select_country: "Por favor, seleccione un país",
  please_select_currency: "Por favor, seleccione una moneda",
  tax_percentage_is_required: "El porcentaje de impuesto es obligatorio",
  click_to_upload: `Haga clic para subir`,
  discount_amount: `Monto del descuento`,
  no_invoice_number: "Sin número de factura",
  vendor_company_ID: "ID de la empresa",
  reference_code: "Código de referencia",
  tax_amount: "Monto del impuesto",
  desigual: {
    profileTitle: "Perfil de Proveedor",
    integrityLinkLabel: "Desigual Integrity",
    profileUpdated: "Perfil actualizado correctamente",
    stepSaved: "Progreso guardado correctamente",
    onboardingCompleted: "Onboarding completado correctamente",
    autosaving: "Guardando",
    autosaved: "Guardado",
    back: "Atrás",
    skip: "Omitir",
    save: "Guardar",
    next: "Siguiente",
    submit: "Enviar",
    yes: "Sí",
    no: "No",
    optional: "opcional",
    stepSupplierData: "Datos del Proveedor",
    stepAddress: "Dirección",
    stepContact: "Contacto",
    stepBanking: "Datos Bancarios",
    stepCurrency: "Moneda",
    stepPaymentTerms: "Condiciones de Pago",
    stepPaymentMethod: "Método de Pago",
    stepDocuments: "Documentos",
    supplierName: "Nombre del Proveedor",
    taxNumber: "NIF",
    entityType: "Tipo de Entidad",
    withholdingTax: "Retención",
    withholdingTaxRate: "Porcentaje de Retención (%)",
    street: "Calle",
    streetNumber: "Número",
    city: "Ciudad",
    regionProvince: "Región / Provincia",
    postalCode: "Código Postal",
    country: "País",
    addContact: "Añadir Contacto",
    fullName: "Nombre Completo",
    language: "Idioma",
    phone: "Teléfono",
    orderEmail: "Correo de Pedidos",
    bankName: "Nombre del Banco",
    bankCode: "Código de Banco",
    accountNumber: "Número de Cuenta",
    checkDigit: "Dígito de Control",
    iban: "IBAN",
    swiftBic: "SWIFT / BIC",
    intermediaryBank: "Banco Intermediario",
    intermediaryBic: "BIC Intermediario",
    currency: "Moneda",
    paymentTerm: "Condición de Pago",
    paymentTermOther: "Descripción de Condición de Pago",
    paymentMethod: "Método de Pago",
    paymentMethodDirectDebit: "Domiciliación Bancaria",
    paymentMethodLetterOfCredit: "Carta de Crédito",
    paymentMethodConfirming: "Confirmando",
    paymentMethodTransfer: "Transferencia",
    bankCertificate: "Certificado Bancario",
    bankCertDate: "Fecha de Emisión del Certificado Bancario",
    bankCertExpiryDate: "Fecha de Caducidad del Certificado Bancario",
    taxCertificate: "Certificado de Residencia Fiscal",
    taxCertIssue: "Fecha de Emisión del Certificado Fiscal",
    taxCertExpiryDate: "Fecha de Caducidad del Certificado Fiscal",
    bankCertExpiredWarning:
      "⚠️ Este certificado bancario tiene más de 1 año de antigüedad. Puedes enviarlo igualmente; se revisará manualmente.",
    taxCertExpiredWarning:
      "⚠️ Este certificado de residencia fiscal tiene más de 1 año de antigüedad. Puedes enviarlo igualmente; se revisará manualmente.",
    viewDocCodeOfEthics: "Código ético",
    viewDocTermsAndConditions:
      "Términos y condiciones generales de contratación de Desigual",
    viewDocDataProcessingAgreement:
      "Contrato de tratamiento de datos personales",
    viewDocument: "Ver Documento",
    whistleblowingTitle: "Nuevo Canal Interno de Denuncias | Integrity Unequal",
    whistleblowingBodyBeforeLink:
      "Hemos habilitado Integrity, nuestro canal interno de denuncias, para que puedas informar de forma confidencial y anónima sobre cualquier conducta irregular relacionada con nuestra relación comercial. Puedes acceder a través del siguiente enlace:",
    whistleblowingBodyAfterLink: "y a través de nuestra web oficial,",
    tcApprovalQuestion: "¿Aceptas los Términos y Condiciones Generales?",
    tcApprovalHelper:
      'Si seleccionas "No", sube tu contrato firmado con Desigual como justificación.',
    signedContract: "Contrato con Desigual (opcional)",
    validation: {
      supplierName: {
        required: "El nombre del proveedor es obligatorio",
        max: "El nombre del proveedor no puede superar los 35 caracteres",
      },
      registrationNumber: { required: "El número de registro es obligatorio" },
      entityType: { required: "El tipo de entidad es obligatorio" },
      withholdingTax: { required: "La selección de retención es obligatoria" },
      withholdingTaxRate: {
        required: "El porcentaje de retención es obligatorio",
        range: "El porcentaje de retención debe estar entre 0 y 100",
      },
      street: {
        required: "La calle es obligatoria",
        max: "La calle no puede superar los 35 caracteres",
      },
      streetNumber: {
        required: "El número es obligatorio",
        max: "El número no puede superar los 10 caracteres",
      },
      city: {
        required: "La ciudad es obligatoria",
        max: "La ciudad no puede superar los 25 caracteres",
      },
      regionProvince: { required: "La región/provincia es obligatoria" },
      postalCode: {
        required: "El código postal es obligatorio",
        max: "El código postal no puede superar los 10 caracteres",
      },
      country: { required: "El país es obligatorio" },
      contacts: { required: "Se requiere al menos un contacto" },
      fullName: {
        required: "El nombre completo es obligatorio",
        max: "El nombre completo no puede superar los 40 caracteres",
      },
      language: { required: "El idioma es obligatorio" },
      phone: { required: "El teléfono es obligatorio" },
      orderEmail: {
        invalid: "Debe ser un correo electrónico válido",
        required: "El correo de pedidos es obligatorio",
      },
      bankName: {
        required: "El nombre del banco es obligatorio",
        max: "El nombre del banco no puede superar los 60 caracteres",
      },
      bankCode: { required: "El código de banco es obligatorio" },
      accountNumber: { required: "El número de cuenta es obligatorio" },
      checkDigit: { required: "El dígito de control es obligatorio" },
      iban: { required: "El IBAN es obligatorio" },
      swiftBic: { required: "El SWIFT / BIC es obligatorio" },
      currency: { required: "La moneda es obligatoria" },
      paymentTerm: { required: "La condición de pago es obligatoria" },
      paymentTermOther: {
        required: "La descripción de la condición de pago es obligatoria",
      },
      paymentMethod: { required: "El método de pago es obligatorio" },
      bankCertificate: { required: "El certificado bancario es obligatorio" },
      bankCertDate: {
        required: "La fecha de emisión del certificado bancario es obligatoria",
      },
      taxCertificate: {
        required: "El certificado de residencia fiscal es obligatorio",
      },
      taxCertIssue: {
        required: "La fecha de emisión del certificado fiscal es obligatoria",
      },
      tcApproval: { required: "Por favor, selecciona Sí o No" },
      signedContract: {
        required: "Por favor, sube tu contrato firmado con Desigual",
      },
    },
  },
};

export default es;
